import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { LoggerService } from '@/shared/logger';
import { deepLinkToPath } from './lib/invite';

interface NavigableRouter {
  navigate: (to: string) => unknown;
  state: { location: { pathname: string } };
}

let launchUrlHandled = false;

/**
 * Native only: open `/join/<roomID>` when the app is launched or resumed from
 * an invite link. Requires associated domains (iOS) / intent filters
 * (Android) in the native projects to actually receive https links.
 */
export const useDeepLinks = (router: NavigableRouter) => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const go = (url?: string | null) => {
      const path = deepLinkToPath(url);
      if (path && router.state.location.pathname !== path) {
        LoggerService.info('Opening invite deep link');
        router.navigate(path);
      }
    };

    if (!launchUrlHandled) {
      launchUrlHandled = true;
      App.getLaunchUrl()
        .then(res => go(res?.url))
        .catch(() => undefined);
    }

    const handle = App.addListener('appUrlOpen', event => go(event.url));
    return () => {
      handle.then(h => h.remove()).catch(() => undefined);
    };
  }, [router]);
};
